// Copyright (c) 2016 Deere & Company

import Part from '@deere/cps-it.warranty-model-factory/lib/part';
import t from 'tcomb';

const Parts = t.dict(t.String, Part, 'Parts');

export const getDefaultState = () => new Parts({});

export default Parts;



// WEBPACK FOOTER //
// ./src/claim/shared/state/parts.js